import React, { useEffect, useState } from 'react';
import moment from 'moment';

import {
  LineText,
  Row,
  Title
} from './styled';

type TournamentCountdownProps = {
  date: string;
};

export const TournamentCountdown = ({ date }: TournamentCountdownProps) => {
  const [timeLeft, setTimeLeft] = useState('');
  const [timeD, setTimeD] = useState('');
  const [timeH, setTimeH] = useState('');
  const [timeM, setTimeM] = useState('');
  const [timeS, setTimeS] = useState('');

  const calculateTimeLeftFull = () => {
    const now = moment().utc();
    const end = moment.utc(date);
    const duration = moment.duration(end.diff(now));
    const totalDays = Math.floor(duration.asDays());
    const hours = duration.hours();
    const minutes = duration.minutes();
    const seconds = duration.seconds();
    setTimeLeft(`${totalDays}d ${hours}h ${minutes}m ${seconds}s`);
  };

  const calculateTimeLeft = () => {
    const now = moment().utc();
    const end = moment.utc(date);
    const duration = moment.duration(end.diff(now));

    const totalDays = Math.floor(duration.asDays());
    const hours = duration.hours();
    const minutes = duration.minutes();
    const seconds = duration.seconds();

    setTimeD(`${totalDays}`);
    setTimeH(`${hours}`);
    setTimeM(`${minutes}`);
    setTimeS(`${seconds}`);
  };

  useEffect(() => {
    calculateTimeLeftFull();
    const intervalIdFull = setInterval(calculateTimeLeftFull, 1000);
    return () => clearInterval(intervalIdFull);
  });

  useEffect(() => {
    calculateTimeLeft();
    const intervalId = setInterval(calculateTimeLeft, 1000);
    return () => clearInterval(intervalId);
  });

  if (timeLeft === '0d 0h 0m 0s') {
    window.location.reload();
  }

    console.log(timeLeft);

    if ('0d 0h 0m 0s' > timeLeft) {
      return <Title>Finished</Title>;
    }

  return (
    <Row>
      <LineText>{timeD}<span>DAYS</span></LineText>
      <LineText>{timeH}<span>HOURS</span></LineText>
      <LineText>{timeM}<span>MINUTES</span></LineText>
      <LineText>{timeS}<span>SECONDS</span></LineText>
    </Row>
  );
};

export default TournamentCountdown;
